import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListCollectionChildrenRequest } from './list-collection-children-request';
import type { IListCollectionChildrenResponse } from './list-collection-children-response';
import { listCollectionChildrenResponseSchema } from './list-collection-children-response';

export async function listCollectionChildrenApi({
  id,
  cursor,
}: IListCollectionChildrenRequest): Promise<IValidatedResponse<IListCollectionChildrenResponse>> {
  return getRequest<IListCollectionChildrenResponse>({
    path: `/sys/collections/${id}/children`,
    schema: listCollectionChildrenResponseSchema,
    options: {
      params: cursor ? { cursor } : undefined,
    },
  });
}
